import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Ayu K.",
    skinType: "Dry Skin",
    product: "Moisturizer",
    quote:
      "SuprSkin is the first brand that actually made my skin feel nourished without irritation. My skin finally feels seen!",
    avatar:
      "https://images.unsplash.com/photo-1597486248015-7e40cb624774?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Nadine T.",
    skinType: "Combination",
    product: "Skin toner",
    quote:
      "The packaging is gorgeous, the ingredients are clean, and my skin has been glowing ever since I started using their toner.",
    avatar:
      "https://images.unsplash.com/photo-1562904403-a5106bef8319?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Samantha L.",
    skinType: "Sensitive",
    product: "Personalized skincare package",
    quote:
      "I’ve tried so many brands, but this one truly feels gentle and thoughtful. The personalised routine is a game changer.",
    avatar:
      "https://images.unsplash.com/photo-1688020741118-00f05ffb15a2?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

const Testimonials = () => {
  return (
    <section className="bg-[#f5eee6] py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#7a6e5f]">
          What Our Customers Say
        </h2>
        <p className="mt-4 text-[#7a6e5f] opacity-80 max-w-xl mx-auto">
          Glowing skin, happy hearts — here’s what they’re saying.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-xl shadow-md p-6 flex flex-col md:flex-row items-start gap-4 text-left"
          >

            <div className="flex-shrink-0">
              <img
                src={testimonial.avatar}
                alt={testimonial.name}
                className="w-16 h-16 rounded-full object-cover"
              />
            </div>

            <div className="flex-1">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <div className="font-semibold text-[#7a6e5f]">{testimonial.name}</div>
                  <div className="text-sm text-[#7a6e5f] opacity-70">
                    {testimonial.skinType}
                  </div>
                  <div className="text-sm text-[#d6a89e] opacity-70 font-semibold pt-[8px]">Product bought: {testimonial.product}</div>
                </div>
                <Quote className="w-5 h-5 text-[#d6a89e]" />
              </div>
              <p className="text-[#7a6e5f] text-sm leading-relaxed opacity-90">
                “{testimonial.quote}”
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
